<template>
  <div>
    <div class="wrapper">
      <v-layout row wrap>
        <v-flex preview>
          <!-- Image background -->
          <div
            ref="heroImage"
            class="image-bg br-0"
            :style="{backgroundImage: getHeroImage(), opacity:projectLP.heroImageOpacity}"
          ></div>
          <div
            class="text-block"
            :class="{'text-left':projectLP.heroAlignment==0, 'text-center':projectLP.heroAlignment==1, 'text-right':projectLP.heroAlignment==2}"
          >
            <!-- class="like-rating" -->
            <div class="like-rating" v-show="false">
              <v-btn class="like px-1" @click="follow()" v-if="!isUserFollower">
                <Icon name="fal fa-heart" size="17" style="padding-right:8px;" colorFont="#C3C6D5" />
                <p>{{ followers }}</p>
              </v-btn>
              <v-btn class="like" @click="unfollow()" v-else>
                <Icon name="fas fa-heart" size="17" style="padding-right:8px;" colorFont="#FA6E6E" />
                <span>{{ followers }}</span>
              </v-btn>
              <div class="rating" v-if="evaluated">
                <v-rating
                  v-model="projectEvaluation.evaluation"
                  :readonly="true"
                  :length="5"
                  empty-icon="fal fa-star"
                  size="17"
                  :dense="true"
                  color="#FFB400"
                  @input="saveEvaluation()"
                ></v-rating>
                <span class="active">{{ projectEvaluation.evaluation }}</span>
              </div>
              <template v-else>
                <div class="rating with-button">
                  <v-rating
                    v-model="currentEvaluationAverange"
                    :readonly="true"
                    half-icon="fas fa-star-half-alt"
                    empty-icon="fal fa-star"
                    full-icon="fas fa-star"
                    :half-increments="true"
                    :length="5"
                    size="17"
                    :dense="true"
                    color="#80849A"
                    background-color="#80849A"
                  ></v-rating>
                  <span class="ml-2">{{ currentEvaluationAverange }}</span>
                </div>
                <v-btn @click="openModalEvaluation" style="margin-left:2px">
                  <i class="fas mr-2 fa-star-exclamation"></i>
                  <span>Avalie</span>
                </v-btn>
              </template>
            </div>
            <h1 class="font-destaque my-3">{{projectLP.project.shortName}}</h1>
            <!-- <h4>{{getCauseAndIncentiveLawText()}}</h4> -->
            <p>{{projectLP.project.objective}}</p>
            <v-btn
              flat
              round
              color="white"
              class="bg-white color-theme-primaria mx-0 mt-4"
              large
              @click="donate()"
              :disabled="checkIfProjectAlreadyExistInTheCart(projectLP.project) || !showDonationButton || (projectLP.project.projectTypeId == ProjectTypes.Ticket && projectLP.project.donationProductList && projectLP.project.donationProductList.length == 0)"
            >{{ showDonationButton ? campaignLandingPage ? campaignLandingPage.donationButtonText : 'Quero doar' : 'Doações Encerradas' }}</v-btn>
          </div>
          <div class="overlay"></div>
        </v-flex>
      </v-layout>
    </div>
    <div class="container p-relative pa-0">
      <div class="logo-instituicao-lp">
        <FileImage :file="projectLP.project.institution.file" :useBg="false" />
        <!-- <img :src="projectLP.project.institution.file.imageContent" /> -->
        <div class="hover-logo-lp">
          <div class="block-hover">
            <h5 class="color-theme-primaria">{{projectLP.project.institution.entity.name}}</h5>
            <p v-html="projectLP.project.institution.mission" class="f-size-12 color-theme-texto"></p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="incentivo"
      :style="{background: 'linear-gradient(90deg, '+colorPrimary+' 0%, '+colorSecondary+' 100%)'}"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12 display-flex py-2">
            <img
              :src="require('@/assets/images/heart.svg')"
              alt
              class="shrink-strong"
              v-if="ProjectTypes.ProjetoIncentivado == projectLP.project.projectTypeId"
            />
            <div
              class="texto-incentivo"
              v-if="ProjectTypes.ProjetoIncentivado == projectLP.project.projectTypeId"
            >
              <h4>{{ getProjectTypeName(projectLP.project.projectTypeId) }}</h4>
              <p>{{ projectLP.project.incentiveLaw ? projectLP.project.incentiveLaw.name : "" }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalEvaluation
      ref="modalEvaluationComponent"
      :projectName="projectLP.project.shortName"
      @evaluate="saveEvaluation"
    ></ModalEvaluation>
  </div>
</template>
<script type="plain/text">
import ProjectService from "@/scripts/services/project.service";
import FileService from "@/scripts/services/file.service";
import FileImage from "@/components/FileImage.vue";
import ProjectEvaluation from "@/scripts/models/projectEvaluation.model";
import ModalEvaluation from "../components/project/ModalEvaluation";
import { Routes } from "@/scripts/models/enums/routes.enum";
import {
  SocialMedia,
  GetSocialMediaLink
} from "@/scripts/models/enums/socialMedias.enum";
import { mapGetters, mapActions } from "vuex";
import {
  ProjectTypes,
  GetProjectTypeName
} from "@/scripts/models/enums/projectTypes.enum.js";
import CommonHelper from "../scripts/helpers/common.helper";
export default {
  components: {
    FileImage,
    ModalEvaluation
  },
  props: [
    "projectLP",
    "showDonationButton",
    "colorPrimary",
    "colorSecondary",
    "campaignLandingPage"
  ],
  data() {
    return {
      titleHoverLogo: "Instituto Beatriz e Lauro Fiuza",
      textHoverLogo:
        'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar. The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks and devious Semikoli, but the Little Blind Text didn’t listen. She packed her seven versalia, put her initial into the belt and made herself on the way. When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane. Pityful a rethoric question ran over her cheek, then she continued her way. On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word "and" and the Little Blind Text should turn around and return to its own, safe country. But nothing the copy said could convince her and so it didn’t take long until a few insidious Copy Writers ambushed her, made her drunk with Longe and Parole and dragged her into their agency, where they abused her for their projects again and again. And if she hasn’t been rewritten, then they are still using her. Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar. The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks and devious Semikoli, but the Little Blind Text didn’t listen. She packed her seven versalia, put her initial into the belt and made herself on the way. When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane. Pityful a rethoric question ran over her cheek, then she continued her way. On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word "and" and the Little Blind Text should turn around and return to its own, safe country. But nothing the copy said could convince her and so it didn’t take long until a few insidious Copy Writers ambushed her, made her drunk with Longe and Parole and dragged her into their agency, where they abused her for their projects again and again. And if she hasn’t been rewritten, then they are still using her. Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar. The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks and devious Semikoli, but the Little Blind Text didn’t listen. She packed her seven versalia, put her initial into the belt and made herself on the way. When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane. Pityful a rethoric question ran over her cheek, then she continued her way. On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word "and" and the Little Blind Text should turn around and return to its own, safe country. But nothing the copy said could convince her and so it didn’t take long until a few insidious Copy Writers ambushed her, made her drunk with Longe and Parole and dragged her into their agency, where they abused her for their projects again and again. And if she hasn’t been rewritten, then they are still using her.Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia.',
      fileService: new FileService(),
      projectService: new ProjectService(),
      projectEvaluation: new ProjectEvaluation(),
      getProjectTypeName: GetProjectTypeName,
      ProjectTypes: ProjectTypes,
      SocialMedia: SocialMedia,
      GetSocialMediaLink: GetSocialMediaLink,
      evaluated: false
    };
  },
  created() {
    this.findEvaluation();
    this.$store.dispatch("setLandingPageConfig");
  },
  computed: {
    ...mapGetters(["alreadyExistsInCart", "userProfile", "logged"]),
    followers() {
      if (this.projectLP.project.followerList)
        return this.projectLP.project.followerList.length;
      return 0;
    },
    isUserFollower() {
      if (
        !this.logged ||
        !this.projectLP.project.followerList ||
        !this.userProfile
      ) {
        return false;
      }

      var userId = this.userProfile.userId;

      var current = this.projectLP.project.followerList.find(
        item => item.userId == userId
      );

      if (current) return true;
      return false;
    },
    currentEvaluationAverange() {
      if (
        this.projectLP.project.evaluationAverage &&
        !this.evaluated &&
        !this.logged
      ) {
        return Math.round(this.projectLP.project.evaluationAverage * 2) / 2;
      }
      return 0;
    }
  },
  watch: {
    logged(oldValue, newValue) {
      if (!oldValue && newValue) this.findEvaluation();
    }
  },
  methods: {
    ...mapActions(["addToCart"]),
    donate() {
      if (
        this.projectLP.project.donationProductList &&
        this.projectLP.project.donationProductList.length > 0
      ) {
        this.$emit("scrollMeTo", "donationProductBlock");
      } else {
        this.addCartItem(this.projectLP.project);
      }
    },
    openModalEvaluation() {
      this.$refs.modalEvaluationComponent.open();
    },
    saveEvaluation(rating) {
      if (rating) {
        this.projectEvaluation.projectId = this.projectLP.project.id;
        this.projectEvaluation.evaluation = rating;
        this.projectService
          .saveProjectEvaluation(this.projectEvaluation)
          .then(data => {
            this.projectLP.project.evaluationAverage = data;
            this.evaluated = true;
          });
      } else {
        CommonHelper.swal("Por favor selecione uma nota válida.");
      }
    },
    findEvaluation() {
      this.projectService
        .findProjectEvaluationByUserAndProject(this.projectLP.project.id)
        .then(
          function(data) {
            console.log(data);
            this.projectEvaluation = data || new ProjectEvaluation();
            this.evaluated =
              this.projectEvaluation.evaluation == 0 ? false : true;
          }.bind(this)
        );
    },
    getCauseAndIncentiveLawText() {
      let result = "";
      if (this.projectLP.project != null) {
        if (this.projectLP.project.cause != null) {
          result += this.projectLP.project.cause.name;
        }
        if (this.projectLP.project.incentiveLaw != null) {
          if (this.projectLP.project.cause != null) {
            result += " - ";
          }
          result += this.projectLP.project.incentiveLaw.name;
        }
      }
      return result;
    },
    checkIfProjectAlreadyExistInTheCart(project) {
      if (project && project.donationProductList.length == 0)
        return this.alreadyExistsInCart({ project: project });
      return false;
    },
    getHeroImage(callback) {
      if (this.projectLP.heroFile) {
        if (this.projectLP.heroFile.hasOwnProperty("imageContent")) {
          return "url(" + this.projectLP.heroFile.imageContent + ")";
        } else {
          this.fileService
            .render(this.projectLP.heroFile.id)
            .then(this.fileService_renderHeroFileCallback);
        }
      }
      return "";
    },
    fileService_renderHeroFileCallback(data) {
      this.$set(this.projectLP.heroFile, "imageContent", data);
    },
    addCartItem(project) {
      project.projectLandingPageConfig = { heroFile: this.projectLP.heroFile };
      var cartItem = {
        project: project
      };
      this.addToCart(cartItem);
    },
    follow() {
      if (this.logged && this.userProfile) {
        this.projectLP.project.followerList.push({
          projectId: this.projectLP.project.id,
          userId: this.userProfile.userId
        });
      }

      this.projectService
        .follow(this.projectLP.project.id)
        .then(newFollower => {
          if (newFollower) {
            var index = this.projectLP.project.followerList.findIndex(
              item =>
                item.userId == newFollower.userId &&
                item.projectId == newFollower.projectId
            );
            this.projectLP.project.followerList[index].id = newFollower.id;
          }
        });
    },
    unfollow() {
      if (this.logged && this.userProfile) {
        let index = this.projectLP.project.followerList.findIndex(
          item =>
            item.userId == this.userProfile.userId &&
            item.projectId == this.projectLP.project.id
        );
        this.projectLP.project.followerList.splice(index, 1);
      }

      this.projectService.unfollow(this.projectLP.project.id);
    }
  }
};
</script>